import React, { useState } from "react";
import { NavLink }     from "react-router-dom";
import { SidebarData } from "../components/data/SitebarData";

type ConsoleSiteBarProps = {
    children: React.JSX.Element | React.JSX.Element[]
}

const ConsoleSiteBar = ({ children }: ConsoleSiteBarProps) => {

    const [isExtended, setIsExtended] = useState<boolean>(false);

    return (
        <div className="nav-grid-root">

            { /* Sitebar Left */}
            <nav className={isExtended ? "nav-grid-aside active" : "nav-grid-aside"}>
                { /* Sitebar button's for toogle sitebar */}
                <div className="nav-grid-aside-header">
                    <button className="link link-primary" onClick={e => setIsExtended(!isExtended)}>
                        <i className="bi bi-list"></i>
                    </button>
                </div>
                <ul className="nav-grid-aside-menu">

                    {SidebarData.map((item, index) => {
                        return (
                            <li key={index}>
                                <NavLink to={item.path}>
                                    <i className={item.icon}></i>
                                    <span className="ms-2">{item.title}</span>
                                </NavLink>
                            </li>
                        )
                    })}

                </ul>
            </nav>

            <main className="nav-grid-content">
                { /* Horizontal Navigationbar | Render Children */}
                {children}
            </main>

        </div>
    )
}
export default ConsoleSiteBar;